import { render, staticRenderFns } from "./ModalInfoBeneficio.vue?vue&type=template&id=77ba0f15&scoped=true&"
import script from "./ModalInfoBeneficio.vue?vue&type=script&lang=js&"
export * from "./ModalInfoBeneficio.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfoBeneficio.vue?vue&type=style&index=0&id=77ba0f15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ba0f15",
  null
  
)

export default component.exports